import React from 'react'
import './index.less'

type LoadingProps = {
    title?: string
}

const Loading: React.FC<LoadingProps> = (props) => {

    const { title } = props

    return (
        <div className='temp-loading'>
            <div className='temp-loading-main'>
                <div className='temp-loading-main-line'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <img src={require(`../../assets/images/loading1.png`)} alt="" />
                <p>{ title || '加载中…'}</p>
            </div>
        </div>
    )
}

export default Loading